import PropTypes from 'prop-types';

import { AD_SLOTS } from 'components/AdSlots/AdSenseSlot';
import LazyHydration from 'components/LazyHydration';

import AdSenseSlot from './AdSenseSlot';

const InContentBannerAdSlot = ({
  className,
  height = 90,
  responsive = false,
  showAdSlotOnBreakpoints,
  slotId = AD_SLOTS.LANDSCAPE_728x90,
  ...rest
}) => (
  <LazyHydration placeholderSize={{ height }}>
    <AdSenseSlot
      className={className}
      height={height}
      showAdSlotOnBreakpoints={showAdSlotOnBreakpoints}
      slotId={slotId}
      {...(responsive
        ? {
            format: 'auto',
            autoHeight: true,
            'data-full-width-responsive': 'true',
          }
        : null)}
      {...rest}
    />
  </LazyHydration>
);

InContentBannerAdSlot.displayName = 'InContentBannerAdSlot';

InContentBannerAdSlot.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  responsive: PropTypes.bool,
  showAdSlotOnBreakpoints: PropTypes.array,
  slotId: PropTypes.string,
};

export default InContentBannerAdSlot;
